const onFirstDrop = {
  // using _ so these global method names won't clash with future local methods
  // This is typically used in the droplet main index.js in the "mounted" hook,
  // with a conditional check if droplet is onPage. See example:
  // this._onFirstDrop(this, () => {
  //   someFunction();
  // });
  methods: {
    _onFirstDrop($vm, fn) {
      if (this._isOnPage($vm) && $vm.droplet.firstDrop) {
        // set first drop to false once it has been dropped
        // for the first time, then execute any function param
        const promise = new Promise((resolve) => {
          if ($vm.$store.dispatch('firstDropStatus', { drp: $vm.droplet })) {
            resolve();
          }
        });
        promise.then(() => {
          // run function parameter
          fn();
        });
      }
    },
    _isOnPage(drp) {
      // TODO this needs to be fixed
      return drp.$parent.$options._componentTag !== 'droplet-container-btn';
    },
  },
};

export { onFirstDrop };



// WEBPACK FOOTER //
// ./src/mixins/first-drop.js